import React, { useState } from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import TermsConditions from '../components/TermsConditions'
import ScrollToTop from '../components/ScrollToTop'

function Terms() {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }
    return (
        <div>
            <ScrollToTop />
            <Sidebar isOpen={isOpen} toggle={toggle} />

            <Navbar toggle={toggle} />

            <TermsConditions />

            <Footer />
        </div>
    )
}

export default Terms